var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngxs/store';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
var npsSurveyLink = 'https://www.research.net/r/BKTXJMC';
var NpsDialogComponent = /** @class */ (function () {
    function NpsDialogComponent(store, dialogRef, data, sanitizer) {
        this.store = store;
        this.dialogRef = dialogRef;
        this.data = data;
        this.sanitizer = sanitizer;
        var profile = this.store.selectSnapshot(AuthState.getUserProfile);
        this.settings = __assign({ surveyEmail: profile ? profile.email : '' }, this.data);
    }
    Object.defineProperty(NpsDialogComponent.prototype, "src", {
        get: function () {
            // generate url w/ params
            var _a = this.settings, surveyGroupName = _a.surveyGroupName, surveyEmail = _a.surveyEmail;
            var url = npsSurveyLink + "?Org=" + surveyGroupName + "&Email=" + surveyEmail;
            return this.sanitizer.bypassSecurityTrustResourceUrl(url);
        },
        enumerable: true,
        configurable: true
    });
    NpsDialogComponent.prototype.ngOnInit = function () {
    };
    NpsDialogComponent.prototype.closeDialog = function () {
        this.dialogRef.close();
    };
    return NpsDialogComponent;
}());
export { NpsDialogComponent };
